<template>
    <div id="payment_wrapper" v-if="loaded">
        <div class="title">{{get_word('payment_step')}}</div>
        <div class="divider"></div>
        <div id="payment_form" :class="{show: loaded }">
            <form ref="myForm" role="form" id="checkout-form" >
                 <div class="form-group" id="card-number-group">
                    <label for="card-number-container" class="control-label">מספר הכרטיס:</label>
                    <div class="input-group input-group-lg">
                        <div id="card-number-container" :class="'form-control payment_input '+cardClass"></div>
                        <span class="input-group-addon"></span>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group" id="social-id-group">
                        <label for="social-id-container" class="control-label">מספר תעודת זהות:</label>
                        <input type="text" v-model="socialId" :class="'form-control payment_input '">
                    </div>

                    <div class="form-group" id="card-expiration-group">
                        <label for="card-expiration-container" class="control-label">תוקף הכרטיס:</label>
                        <div id="card-expiration-container" :class="'form-control payment_input '+expClass"></div>
                    </div>
                    <div class="form-group" id="card-cvv-group">
                        <label for="card-cvv-container" class="control-label">CVV:</label>
                        <div id="card-cvv-container" :class="'form-control payment_input '+cvvClass"></div>
                    </div>
                </div>
                <div class="row_bottom">
                    <div class="total" v-if="paymentData && paymentData.price != ''">
                        <div class="title">לתשלום: <span>{{ parseFloat(paymentData.price) }}₪</span></div>
                    </div>

                    <div class="payment_btn_wrapper">
                        <button class="subscribe btn dom submit btn-lg btn-block" id="submit-button" :disabled="!isLoading && !allow_to_pay">
                            לתשלום
                            <div id="loading" v-if="isLoading" ></div>
                        </button>
                    </div>
                </div>

                <div class="row" style="display:none;" id="checkout-form-errors">
                    <p class="payment-errors"></p>
                </div>
		</form>
	</div>
    </div>
</template>

<script>
export default {
    props:["payment_id", "payme_client_key"],
    data() {
        return {
            paymentData: {id: '', price: '', first_name: '', last_name: '', email: '', phone: ''},
            orderData:[],
            installments: 1,
            nameClass:'',
            socialId:'',
            expClass:'',
            cvvClass:'',
            cardClass:'',
            socialClass: '',
            saveToken:false,
            isLoading:false,
            allow_to_pay:false,
            loaded:false,
            allFieldsReady:[],
            number:false,
            exp:false,
            name:false,
            social:false,
            cvv:false,
            cardSettings : {
                placeholder: '0000-0000-0000-0000',
                messages: { invalid: this.get_word('invalid_card_num'),required:this.get_word('required') },
                styles: {
                    base: {
                        '::placeholder': { 'text-align': 'right' },
                        'text-align': 'right'
                    },
                    valid: { 'color': '#354e68' }
                }
            },
            expSettings : {
                placeholder: 'MM/YY',
                messages: { invalid: this.get_word('invalid_exp_data'),required:this.get_word('required') },
                styles: {
                    base: {
                        '::placeholder': { 'text-align': 'right' },
                        'text-align': 'right'
                    },
                    valid: { 'color': '#354e68' }
                }
            },
            cvvSettings : {
                placeholder: 'CVV',
                messages: { invalid: this.get_word('invalid_cvv'),required:this.get_word('required') },
                styles: {
                    base: {
                        '::placeholder': { 'text-align': 'right' },
                        'text-align': 'right'
                    },
                    valid: { 'color': '#354e68' }
                }
            },
        }
    },

mounted() {
    this.api({ action: 'signup/get_payment', data: {token: this.payment_id}}, (data) => {
        this.paymentData.id = data.data.payment.id;
        this.paymentData.price = data.data.payment.amount;
        this.paymentData.first_name = data.data.user.display_name.split(' ')[0]
        this.paymentData.last_name = data.data.user.display_name.split(' ')[1]
        this.paymentData.email = data.data.user.username;
        this.paymentData.phone = data.data.user.phone;
        this.loaded = true;
        this.init();
    })
},
methods:{
    init(){
        this.socialId = this.id_card;
        const allFieldsReady = [];
        const apiKey = '802c7791-0954-47bb-a8c2-f2c541ae90e0';

        PayMe.create(apiKey, { testMode: false }).then((instance) => {
        const fields = instance.hostedFields();
        const cardNumber = fields.create(PayMe.fields.NUMBER, this.cardSettings);
        allFieldsReady.push(cardNumber.mount('#card-number-container'));
        cardNumber.on('keyup', state => this.toggleValidationMessages('card',state));
        cardNumber.on('validity-changed', state => this.toggleValidation('card',state));

        const cardExpiration = fields.create(PayMe.fields.EXPIRATION,this.expSettings);
        allFieldsReady.push(cardExpiration.mount('#card-expiration-container'));
        cardExpiration.on('keyup', state => this.toggleValidationMessages('exp',state));
        cardExpiration.on('validity-changed', state => this.toggleValidation('exp',state));

        const cardCvv = fields.create(PayMe.fields.CVC, this.cvvSettings);
        allFieldsReady.push(cardCvv.mount('#card-cvv-container'));
        cardCvv.on('keyup', state => this.toggleValidationMessages('cvv',state));
        cardCvv.on('validity-changed', state => this.toggleValidation('cvv',state));

        const formElement = this.$refs.myForm;
        Promise.all(allFieldsReady).then(() => this.allow_to_pay = true);

        formElement.addEventListener('submit', ev => {
            ev.preventDefault();
            if(!this.number || !this.cvv || !this.exp || this.isLoading || !this.allow_to_pay) {
                alert('אנא מלא את כל השדות');
                return false;
            }

            const sale = {
                payerFirstName: (this.paymentData.first_name ?? 'כללי'),
                payerLastName: (this.paymentData.last_name ?? 'כללי'),
                payerEmail: (this.paymentData.email ?? 'support@tech1.co.il'),
                payerPhone: (this.paymentData.phone ?? '0523339333'),
                payerSocialId: this.socialId,
                total: {
                    label: this.paymentData.id,
                    amount: {
                        currency: 'ILS',
                        value: (Number(parseFloat(this.paymentData.price)) > 0 ? String(parseFloat(this.paymentData.price)) : '5'),
                    }
                }
            };
            this.isLoading = true;

            instance.tokenize(sale)
            .then(postData => {
                this.api({ action: "signup/payment_save_token", method: "post", data: { postData: {...postData, payment_id: this.paymentData.id, installments: this.installments}, saveToken: this.saveToken } }, (chargeData) => {
                    if(chargeData.data.status) {
                        this.$emit("payment_success", chargeData.data.order_id);
                    } else {
                        this.isLoading = false;
                        this.$emit("fail_msg");
                    }
                });
            }).catch(err => {
                this.isLoading = false;
                console.log(err);
                this.alert('לא ניתן לבצע את התשלום');
                return true;
            });
        });
        }).catch(err => {
            this.isLoading = false;
            console.log(err);
            this.alert('לא ניתן לבצע את התשלום');
            return true;
        });
    },

    toggleValidationMessages(name, validationState) {
        const map = { card: 'cardClass', exp: 'expClass', cvv: 'cvvClass', name: 'nameClass', social: 'socialClass' };
        const key = map[name];
        if (!key) return;
        if (validationState.isValid) this[key] = 'valid';
        else if (!validationState.isEmpty && !validationState.isValid) this[key] = 'invalid';
        else this[key] = '';
    },
    toggleValidation(name, validationState) {
        const map = { card: 'number', exp: 'exp', cvv: 'cvv', name: 'name', social: 'social' };
        const key = map[name];
        if (!key) return;
        this[key] = validationState.isValid;
    }
},
}
</script>
<style scoped lang="scss">
#payment_wrapper{display: flex;flex-direction: column;justify-content: center;align-items: center;gap: var(--gap_mbl);text-align: center;background-color: var(--bg_color);padding: 0px;width: 100%;}
#payment_form{
    &{display: flex; flex-direction: column; align-content: center; align-items: center;color: #fff;padding: 2px ;}
    @media (min-width: 600px) {width: 80%;}
    @media (max-width: 600px) {width: 90%;}
    form{width: 100%;display: flex;flex-direction: column;gap:var(--gap_mbl);}
    label,p{color:#0a1130;text-align: right;display: block;font-size: 18px;margin-bottom: 5px;display: block;}
    p{margin: 0 !important;}
    .payment_btn_wrapper{
        .btn{height: 40px; font-size: 24px;
            @media (min-width: 600px) {}
            @media (max-width: 600px) {width: 50vw;max-width: 150px;}
        }   
    }
    .row{ display: grid;grid-template-columns: repeat(2, 1fr);gap: 20px;justify-content: space-between;
        @media (min-width: 600px) { .form-group{ width: 100%} }
        @media (max-width: 600px) {flex-direction:column;}
    }
    .input-lg{
        &{height: 35px;border-radius: 8px;min-width: 260px;}
        @media (min-width: 600px) {background-color: #fff;padding: 5px 10px;}
        @media (max-width: 600px) {border: 1px solid #D4DADA !important;padding: 5px;background: #F5F5F6;}
    }
}
.row_bottom{display: flex;align-items: center;justify-content: space-between;margin-top: var(--gap_big);
    @media (min-width: 600px) {gap: 20px;}
    @media (max-width: 600px) {gap: 10px;flex-direction: column;}
    .total{color:#0a1130;
        .title{font-size: 28px;font-weight: bold;
            @media (max-width: 600px) {}
            @media (min-width: 600px) {}
        }
        span{font-weight: 400;}
    }
    .btn{gap: 8px !important;}
}
.payment_input{width:100%; height: 50px; background: #fff; border:none; border-radius: 12px;padding: 0 15px;font-size: 20px;outline: none;color: #0a1130;position: relative;}
.payment_input.invalid{border: 1px solid #D83F3F;}
.payment_input.valid{border: 1px solid #73C7AD;}
#loading {
    display: inline-block; width: 20px; height: 20px;
    border: 3px solid rgba(255,255,255,.3); border-radius: 50%; border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
